module.exports = __webpack_public_path__ + "img/mile1.fd7ee7c5.webp";